<template>
  <custom-dialog
    width="1400px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <!-- 业务信息 -->
      <div class="bus-msg">
        <div class="item-title">{{ $t('crm_cancel_dialog.ye_wu_xin_xi') }}</div>
        <div class="params">
          <div class="row">
            <div class="col">
              <div class="kv">
                <div class="key">{{ $t('crm_cancel_dialog.ding_dan_hao') }}：</div>
                <div class="val">{{ info.orderGoodsCode || '-' }}</div>
              </div>
            </div>
            <div class="col">
              <div class="kv">
                <div class="key">{{ $t('crm_cancel_dialog.chuang_jian_ri_qi') }}：</div>
                <div class="val">{{ rowData.gmtCreate ? $momentLocal(rowData.gmtCreate, 'YYYY-MM-DD') : '-' }}</div>
              </div>
            </div>
            <div class="col">
              <div class="kv">
                <div class="key">{{ $t('crm_cancel_dialog.chan_pin_xing_hao') }}：</div>
                <div class="val">{{ info.productCode || '-' }}</div>
              </div>
            </div>
            <div class="col">
              <div class="kv">
                <div class="key">{{ $t('crm_cancel_dialog.ji_shen_hao') }}：</div>
                <div class="val">{{ info.bodyNum || '-' }}</div>
              </div>
            </div>
            <div class="col">
              <div class="kv">
                <div class="key">{{ $t('crm_cancel_dialog.ye_wu_zhuang_tai') }}：</div>
                <div class="val">{{ info.deviceBizState ? getDicValue('order_device_biz_state', info.deviceBizState) : '-' }}</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="kv">
                <div class="key">{{ $t('crm_cancel_dialog.ljzlys') }}：</div>
                <div class="val">{{ info.totalRentalMonth || '-' }}</div>
              </div>
            </div>
            <div class="col">
              <div class="kv">
                <div class="key">{{ $t('crm_cancel_dialog.zbyszj') }}：</div>
                <div class="val">{{ info.totalReceivedRentalHq || '-' }}</div>
              </div>
            </div>
            <!-- <div class="col">
              <div class="kv">
                <div class="key">{{ $t('p_giftPartOrderCancelD_zstj') }}：</div>
                <div class="val">{{ info.triggerCondition || '-' }}</div>
              </div>
            </div> -->
            <div class="col">
              <div class="kv">
                <div class="key">{{ $t('crm_cancel_dialog.zhang_qi') }}：</div>
                <div class="val">{{ info.billTermNum ? `${info.billTermNum}/${info.billTotalTerm}` : '-'}}</div>
              </div>
            </div>
            <div class="col">
              <div class="kv">
                <div class="key">{{ $t('crm_cancel_dialog.shou_hou_gong_si') }}：</div>
                <div class="val">{{ info.afterServiceName || '-' }}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="search-hd">
        <el-form
          :inline="true"
          @submit.native.prevent
        >
          <el-form-item>
            <div class="item-title">{{ $t('crm_cancel_dialog.xzxzfdd') }}</div>
          </el-form-item>
          <!-- 返库数量 赠送数量 -->
          <el-form-item style="float:right;">
            <div class="table-sum-params">
              <div class="sum-item">
                <div class="key">{{ $t('crm_cancel_dialog.zeng_song_shu_liang') }}：</div>
                <div class="val selected-num">{{ present }}</div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          tableCode="free_acc_order_cancel"
          :data="data"
          :slots="['isReturnHq']"
        >
          <template v-slot:isReturnHq="scope">
            <el-radio
              v-model="scope.row.isReturnHq"
              :label="true"
            >{{ $t('Common.com_yes') }}</el-radio>
            <el-radio
              v-model="scope.row.isReturnHq"
              :label="false"
            >{{ $t('Common.com_no') }}</el-radio>
          </template>
        </custom-table>
      </div>
      <el-form
        class="form"
        :model="form"
        :rules="rules"
        ref="form"
      >
        <div class="reason">
          <div class="item-title required">{{ $t('crm_cancel_dialog.zuo_fei_yuan_yin') }}</div>
          <div class="reason-content">
            <el-form-item prop="reason">
              <el-input
                type="textarea"
                v-model="form.reason"
                :autosize="{ minRows: 4, maxRows: 4 }"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
        :disabled="isSubmit"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      // 搜索keyword - 本地使用
      search: '',
      actualSearch: '',
      data: [],
      pageSize: 8,
      pageNum: 1,

      form: {
        reason: '',
      },

      isSubmit: false,

      info: {},
    };
  },
  computed: {
    rules() {
      return {
        reason: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 200,
            message: this.$t('Common.com_rules_length_max', [200])
          },
        ],
      };
    },
    present() {
      return this.data.reduce((total, obj) => total + (parseInt(obj.bookingNum, 10) || 0), 0);
    },
    rowData() {
      const row = this.model.data[0];
      return row || {};
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // const rows = this.model.data.map((item) => {
      //   const obj = {
      //     ...item,
      //     isReturnHq: false,
      //   };
      //   return obj;
      // });
      // this.data = rows;
      const row = this.model.data[0];

      const reqData = {
        orderGoodsCode: row.orderGoodsCode,
      };

      this.$getJSON(apis.giveawayDetail, reqData).then((res) => {
        this.info = res.data;
        this.data = this.info.goodsList;
      });
    },

    onConfirm() {
      this.$refs.form.validate((validate) => {
        if (validate) {
          const reqData = {
            orderGoodsCode: this.info.orderGoodsCode,
            disposalReason: this.form.reason,
          };

          if (this.isSubmit) {
            return;
          } else {
            this.isSubmit = true;
          }

          this.$postJSON(apis.giveawayCancel, reqData)
            .then(() => {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.isSubmit = false;
              this.$emit('confirm');
              this.close();
            })
            .catch(() => {
              this.isSubmit = false;
            });
        }
      });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  margin-top: 26px;
}

.bus-msg {
  // margin-top: 24px;
  .part-msg {
    margin-top: 35px;

    .header {
      overflow: hidden;
      .item-title {
        float: left;
      }

      .table-sum-params {
        float: right;
        overflow: hidden;

        .sum-item {
          float: left;
          line-height: 22px;
          font-size: 12px;
          color: #606266;

          &:last-child {
            .selected-num {
              padding: 0;
            }
          }

          .selected-num {
            padding: 0 20px 0 0;
            color: #0d9ae0;
          }

          .key,
          .val {
            float: left;
          }
        }
      }
    }

    .table-container {
      overflow: hidden;
      max-height: 300px;
    }
  }

  .send-msg {
    margin-top: 35px;
  }

  .params {
    .row {
      overflow: hidden;
    }

    .col {
      float: left;
      width: 20%;
    }
    .kv {
      overflow: hidden;
      display: flex;
      font-size: 12px;
      line-height: 16px;
      padding: 10px 0;

      .key {
        width: 120px;
      }
      .val {
        flex: 1;
        padding-right: 10px;
      }
    }
  }
}

.table-sum-params {
  float: right;
  overflow: hidden;

  .selected-num {
    padding: 0 5px;
    color: #0d9ae0;
  }

  .sum-item {
    float: left;
    line-height: 22px;
    font-size: 12px;
    color: #606266;

    .key,
    .val {
      float: left;
    }
  }
}

.search-hd {
  padding-top: 20px;
  padding-bottom: 0;
}

// .dialog-body {
//   padding-bottom: 0 !important;
// }
</style>
